var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "rich-content"
  }, [_c('div', {
    staticClass: "rich-content__widget",
    class: [{
      'rich-content__widget_collapse': _vm.isActive
    }]
  }), _vm._v(" "), _vm.showButton ? _c('button', {
    staticClass: "rich-content__button",
    class: [{
      'rich-content__button_active': _vm.isActive
    }],
    on: {
      "click": function ($event) {
        _vm.isActive = !_vm.isActive;
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.isActive ? 'Свернуть описание' : 'Развернуть описание') + "\n  ")]) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }